import { type Routes } from '@angular/router';
import { canAccessProtectedRoutesGuard } from './guards/can-access-protected-routes.guard';

export const routes: Routes = [
  {
    path: 'public',
    loadChildren: () => import('./public/routes').then(pub => pub.routes)
  },
  {
    path: 'oauth-error',
    title: 'oauthError',
    loadComponent: () => import('./pages/oauth-error/oauth-error.component').then(mod => mod.OauthErrorComponent)
  },
  {
    path: 'not-found',
    title: 'notFound',
    loadComponent: () => import('./pages/not-found/not-found.component').then(mod => mod.NotFoundComponent)
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () => import('./auth/login.component').then(mod => mod.LoginComponent)
  },
  {
    path: 'print',
    canActivate: [canAccessProtectedRoutesGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./print/routes').then(print => print.routes)
      }
    ]
  },
  {
    path: '',
    canActivate: [canAccessProtectedRoutesGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./layout/routes').then(layout => layout.routes)
      }
    ]
  },
  {
    path: '**',
    canActivate: [canAccessProtectedRoutesGuard],
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
